(self["webpackChunkschoolmusicalco"] = self["webpackChunkschoolmusicalco"] || []).push([["/readmore"],{

/***/ "./src/js/readmore.js":
/*!****************************!*\
  !*** ./src/js/readmore.js ***!
  \****************************/
/***/ (() => {

function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var readmorecontent = document.querySelector(".readmore-content");
var readmore = document.querySelector(".readmore");
var p_tags = document.querySelectorAll(".readmore-content p");
var expand = false;
var tags = [];
var readmoretext = "Read More";
var readlesstext = "Read Less";
var show = function show() {
  tags.forEach(function (tag) {
    tag.style.display = "block";
  });
  expand = true;
  readmorecontent.classList.add("reading-more");
  readmorecontent.style.maxHeight = readmorecontent.scrollHeight + "px";
};
var hide = function hide() {
  tags.forEach(function (tag) {
    tag.style.display = "none";
  });
  expand = false;
  readmorecontent.classList.remove("reading-more");
  readmorecontent.style.maxHeight = null;
};
if (p_tags && p_tags.length > 1) {
  tags = _toConsumableArray(p_tags).slice(1);
  hide();
}
var showMore = function showMore(e) {
  e.preventDefault();
  if (e.target.dataset.less) {
    readlesstext = e.target.dataset.less;
  }
  expand = !expand;
  expand ? show() : hide();
  e.target.textContent = expand ? readlesstext : readmoretext;
};
if (readmore) {
  readmoretext = readmore.textContent;
  readmore.addEventListener("click", showMore);
}

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__("./src/js/readmore.js"));
/******/ }
]);